"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubCampaign = exports.isParentCampaign = exports.isCampaignProduct = exports.isCampaignBatchProducts = exports.CampaignItemType = void 0;
var CampaignItemType;
(function (CampaignItemType) {
    CampaignItemType["batchProducts"] = "batchProducts";
    CampaignItemType["product"] = "product";
})(CampaignItemType = exports.CampaignItemType || (exports.CampaignItemType = {}));
exports.isCampaignBatchProducts = (item) => item.type === CampaignItemType.batchProducts;
exports.isCampaignProduct = (item) => item.type === CampaignItemType.product;
exports.isParentCampaign = (item) => (item === null || item === void 0 ? void 0 : item.parentCampaignId) === undefined && (item === null || item === void 0 ? void 0 : item.parentCampaignEnvironmentId) === undefined;
exports.isSubCampaign = (item) => (item === null || item === void 0 ? void 0 : item.parentCampaignId) && (item === null || item === void 0 ? void 0 : item.parentCampaignEnvironmentId);
//# sourceMappingURL=campaigns.js.map